<template>
    <!-- 居民列表 -->
    <div>
      <el-row>
        <!-- 工具条 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom: 0px"
          @submit.native.prevent>
          <el-form-item label="居民姓名">
            <el-input class="width80" clearable v-model.trim="formInline.name" placeholder="请输入长者姓名"
              @keyup.enter.native.prevent="enterSearchMember"></el-input>
          </el-form-item>
          <el-form-item label="所属社区:">
            <el-input class="width80" clearable v-model.trim="formInline.community" placeholder="请输入社区"></el-input>
          </el-form-item>
          <el-form-item label="人员类别">
            <el-input class="width80" clearable v-model.trim="formInline.label" placeholder="请输入人员类别"
              @keyup.enter.native.prevent="enterSearchMember"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search" plain>查询</el-button>
            <el-button type="warning" icon="el-icon-plus" @click="addOrder" plain>添加</el-button>
          </el-form-item>
        </el-form>
        <el-table style="width: 100%" :data="tableData" v-loading="tableLoading" :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :row-style="tableRowStyle">
          <el-table-column prop="name" label="居民姓名" min-width="100"></el-table-column>
          <el-table-column prop="sex" label="性别" min-width="50"></el-table-column>
          <el-table-column prop="age" label="年龄" min-width="50"></el-table-column>
          <el-table-column prop="idCard" label="身份证号" min-width="175"></el-table-column>
          <el-table-column prop="phone" label="电话" min-width="120"></el-table-column>
          <el-table-column prop="guardian" label="监护人" min-width="100"></el-table-column>
          <el-table-column prop="guardianPhone" label="监护人电话" min-width="120"></el-table-column>
          <el-table-column prop="liveStreet" label="居住街道" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="liveCommunity" label="当前社区" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="liveAddress" label="居住地址" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="label" label="老人类别" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="healthStatus" label="身体状况" min-width="100"></el-table-column>
          <el-table-column label="操作" min-width="120">
            <template slot-scope="scope">
              <a @click="handleEdit(scope.$index, scope.row)" class="curcor">
                <img class="handedness" src="@/assets/beadhouse/xiugai_icon_1.png" />
              </a>
              <a @click="handleDelete(scope.$index, scope.row)" class="curcor" style="margin-left: 8px;">
                <img class="handedness" src="@/assets/beadhouse/shanhcu.png" />
              </a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize"
          align="center" class="fenye">
        </el-pagination>
        <!-- 报表上传 -->
        <el-dialog title="长者表格导入" width="30%" :visible.sync="toLeadVisisble" :close-on-click-modal="false"
          @close="toLeadCloseDialog">
          <el-row type="flex" justify="center">
            <el-col :span="20">
              <el-row>
                <el-col :span="24">
                  <input type="file" ref="file" id="file" @change="getUrl" />
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <div slot="footer" class="dialog-footer" align="center">
            <el-button @click.native="toLeadVisisble = false">取消</el-button>
            <el-button type="primary" @click.native="intoForm">确定</el-button>
          </div>
        </el-dialog>

        <el-drawer 
            :visible.sync="addVisible"
            :title="addForm.id?'修改居民档案':'新增居民档案'"
            size="600px"
            custom-class="demo-drawer">
            <div class="demo-drawer__content">
                <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="姓名" prop="name">
                          <el-input v-model.trim="addForm.name" placeholder="请输入居民姓名" auto-complete="off" maxlength="15" class="width80"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="身份证号" prop="idCard" ref="idCard">
                          <el-input v-model="addForm.idCard" auto-complete="off" placeholder="请输入身份证号码" class="width80"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="户籍城市" prop="birthCity">
                          <el-input v-model="addForm.birthCity" placeholder="请输入户籍城市名称" class="width80" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="户籍街道" prop="birthStreet" style="margin-top: -15px;">
                          <el-input v-model="addForm.birthStreet" placeholder="请输入户籍街道名称" class="width80" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="户籍社区" prop="birthCommunity" style="margin-top: -15px;">
                          <el-input v-model="addForm.birthCommunity" placeholder="请输入户籍社区名称" class="width80" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="详细地址" prop="birthAddress" style="margin-top: -15px;">
                          <el-input v-model="addForm.birthAddress" placeholder="请输入详细地址" class="width80" maxlength="20"></el-input>
                        </el-form-item>
                      </el-col>

                      <el-col :span="12">
                        <el-form-item label="现居城市" prop="liveCity">
                          <el-input v-model="addForm.liveCity" placeholder="请输入现居城市" class="width80" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="居住街道" prop="liveStreet" style="margin-top: -15px;">
                          <el-input v-model="addForm.liveStreet" placeholder="请输入现居住街道" class="width80" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="居住社区" prop="liveCommunity" style="margin-top: -15px;">
                          <el-input v-model="addForm.liveCommunity" placeholder="请输入现居住社区" class="width80" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="详细地址" prop="liveAddress" style="margin-top: -15px;">
                          <el-input v-model="addForm.liveAddress" placeholder="请输入详细地址" class="width80" maxlength="20"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="联系方式" prop="phone">
                            <el-input v-model.trim="addForm.phone" placeholder="请输入联系方式" maxlength="15" class="width80"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="居住状态" prop="inStatus">
                            <el-select
                                 v-model="addForm.inStatus"
                                 placeholder="请选择"
                                 clearable
                                 class="width80"
                               >
                                 <el-option label="独居" value="1"></el-option>
                                 <el-option label="夫妻相伴" value="2"></el-option>
                                 <el-option label="子女同住" value="3"></el-option>
                                 <el-option label="保姆照顾" value="4"></el-option>
                                 <el-option label="其他" value="5"></el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="长者标签" prop="label">
                            <el-select
                                 v-model="addForm.label"
                                 placeholder="请选择"
                                 clearable
                                 class="width80"
                               >
                               <el-option label="低保户" value="低保户"></el-option>
                               <el-option label="城市三无人员" value="城市三无人员"></el-option>
                               <el-option label="低保边缘" value="低保边缘"></el-option>
                               <el-option label="三线老军工" value="三线老军工"></el-option>
                               <el-option label="三五下放人员" value="三五下放人员"></el-option>
                               <el-option label="供养人员" value="供养人员"></el-option>
                               <el-option label="农村五保" value="农村五保"></el-option>
                               <el-option label="经济困难老人" value="经济困难老人"></el-option>
                               <el-option label="70周岁及以上的计生特扶老人" value="70周岁及以上的计生特扶老人"></el-option>
                               <el-option label="百岁老人" value="百岁老人"></el-option>
                               <el-option label="普通" value="普通"></el-option>
                               <el-option label="90周岁以上老人" value="90周岁以上老人"></el-option>
                               <el-option label="城镇职工" value="城镇职工"></el-option>
                               <el-option label="高知" value="高知"></el-option>
                               <el-option label="高干" value="高干"></el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>
    
                      <el-col :span="12">
                        <el-form-item label="身体情况" prop="healthStatus">
                            <el-select
                                 v-model="addForm.healthStatus"
                                 placeholder="请选择"
                                 clearable
                                 class="width80"
                               >
                               <el-option label="健康" value="健康"></el-option>
                                <el-option label="无残疾" value="无残疾"></el-option>
                                <el-option label="轻度残疾" value="轻度残疾"></el-option>
                                <el-option label="中度残疾" value="中度残疾"></el-option>
                                <el-option label="重度残疾" value="重度残疾"></el-option>
                                <el-option label="其他" value="其他"></el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="监护人" prop="guardian">
                            <el-input v-model.trim="addForm.guardian" placeholder="请输入监护人姓名" maxlength="15" class="width80"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="监护人电话" prop="guardianPhone">
                            <el-input v-model.trim="addForm.guardianPhone" placeholder="请输入监护人联系方式" maxlength="15" class="width80"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                </el-form>
                <div class="demo-drawer__footer" style="padding-left: 240px;">
                    <el-button type="warning" style="width: 150px;" plain @click="closeAdd">返回</el-button>
                    <el-button type="primary" style="width: 150px;" plain @click="submitData" :loading="addLoading">完成</el-button>
                </div>
            </div>
        </el-drawer>


      </el-row>
    </div>
  </template>
  <script>
  import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
  import { baseURL } from "@/utils/request.js";
import {
  validateOldId,
  validateEgPhonea,
  validategNamea,
  validateInput
} from "@/utils/validator.js";
  export default {
    name: "ResidentManager",
    data() {
      return {
        formInline: {
            name: "",
            community: "",
            label: "",
        },
        areaList:[],
        addVisible:false,
        tableData: [], //表格数据
        tableLoading: false, //表格加载的loading
        /* 分页的 */
        currentPage: 1, //初始页
        toLeadVisisble: false,
        personReduceOptions:[],
        pageNo: 1, //页码
        pageSize: 10, //每页显示的条数
        totalDataNumber: 0, //数据的总数,
        formSelect: [
          {
            label: "男",
            value: "0",
          },
          {
            label: "女",
            value: "1",
          },
        ],
        addForm: {
          name: "",
          idCard: "",
          birthCity: "",
          birthStreet: "",
          birthCommunity: "",
          birthAddress: "",
          liveCity: "",
          liveStreet: "",
          liveCommunity: "",
          liveAddress: "",
          phone: "",
          inStatus:"",
          label:"",
          healthStatus:"",
          guardian:"",
          guardianPhone:""
        },
        addFormRules: {
            name: [
              { required: true, message: "请输入姓名", trigger: "blur" },
              { min: 1, max: 10, message: "长度在 1到 10 位的字符" }
            ], //by guo 2019-11-26-13:04修改
            idCard: [
              { required: true, validator: validateOldId, trigger: "blur" }
            ],
            phone: [{
              required: true, message: "请输入联系电话", trigger: "blur"
            }],
        },
        addLoading:false,
        fieldsVisisble: false,
        oldNameOptions: [], // 老人姓名集合
      };
    },
    methods: {
      //修改table tr行的背景色
      tableRowStyle({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
          return "background-color: #ffffff";
        } else {
          return "background-color: #e4f5f8";
        }
      },
      closeAdd(){
        this.addForm = {
            name: "",
            idCard: "",
            birthCity: "",
            birthArea: "",
            birthCommunity: "",
            birthAddress: "",
            liveCity: "",
            liveArea: "",
            liveCommunity: "",
            liveAddress: "",
            phone: "",
            inStatus:"",
            label:"",
            healthStatus:"",
            guardian:"",
            guardianPhone:""
        };
        this.addVisible = false;
      },
      submitData(){
        this.$refs.addForm.validate(valid => {
            console.log(valid);
            if(valid){
                let params = new Object();
                params = Object.assign({}, this.addForm);
                params.groupId = sessionStorage.getItem("groupId");
                let url = "";
                if(params.id){
                    url = "omc/elder/edit";
                }else{
                    url = "omc/elder/add";
                }
                delete params.sex;
                delete params.age;
                this.tableLoading = true;
                this.$postJson(url, params).then((res) => {
                    this.tableLoading = false;
                    if (res.code == 200) {
                        this.$message({
                            message: res.message,
                            type: "success"
                        });
                        this.closeAdd();
                        this.queryOldman();
                    }
                });
            }
        });
      },
      /*
        修改老人信息
      */
      handleEdit(index, row) {
        console.log(row)
        this.addForm = Object.assign({}, row);
        this.addVisible = true;
      },
      /*
        添加老人
      */
      addOrder() {
        this.addVisible = true;
        this.addForm = {
            name: "",
            idCard: "",
            birthCity: "",
            birthArea: "",
            birthCommunity: "",
            birthAddress: "",
            liveCity: "",
            liveArea: "",
            liveCommunity: "",
            liveAddress: "",
            phone: "",
            inStatus:"",
            label:"",
            healthStatus:"",
            guardian:"",
            guardianPhone:""
        };
      },
      /*
        点击查询
      */
      search() {
        this.queryOldman(
          this.formInline.oldName,
          this.formInline.interest,
          (this.pageNo = 1),
          (this.pageSize = 10)
        );
      },
  
      /*
        键盘事件 按下键盘回车 查询
      */
      enterSearchMember(e) {
        // console.log("回车搜索", keyCode, e);
        var keyCode = window.event ? e.keyCode : e.which;
        if (keyCode == 13 && this.formInline.oldName != null) {
          this.search();
        }
      },
      handleDelete(index, row) {
        this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                this.$postJson("omc/elder/deleteById/"+row.id, {}).then(res=>{
                    this.$message({
                        message: res.message,
                        type: "success"
                    });
                    this.queryOldman();
                })
            })
      },
      /*
        查询老人分页列表
      */
      queryOldman() {
        // console.log(this.formInline.status == "0");
        let params = {};
        if (this.formInline.name != "" || null || undefined) {
          params.name = this.formInline.name;
        }
        if (this.formInline.community != "" || null || undefined) {
          params.community = this.formInline.community;
        }
        if (this.formInline.label != "" || null || undefined) {
          params.label = this.formInline.label;
        }
        params.pageNum = String(this.pageNo);
        params.pageSize = String(this.pageSize);
        // params.serviceType = 0;
        this.tableData = [];
        this.tableLoading = true;
        this.$postJson("omc/elder/listWithPage", params).then((res) => {
          if (res.code == 200) {
            if (res.result.list != null) {
              this.pageSize = res.result.pageSize;
              this.currentPage = res.result.pageNum;
              this.totalDataNumber = res.result.total * 1;

              res.result.list.forEach((item) => {
                var object = {};
                item.age = this.getAgeFromIdCard(item.idCard);
                item.sex = this.getSexFromIdCard(item.idCard);
                object = Object.assign({}, item);
                object.sex = item.sex == 0 ? "男" : "女";
                this.tableData.push(object);
              });

            } else {
              this.tableData = [];
              this.pageSize = 10;
              this.currentPage = 1;
              this.totalDataNumber = 0;
            }
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
          this.tableLoading = false;
        });
      },
      getAgeFromIdCard(idCard){
        if (!idCard || idCard.length !== 18) {
            return '-';
        }
        const birthYear = idCard.substring(6, 10);
        const birthMonth = idCard.substring(10, 12);
        const birthDay = idCard.substring(12, 14);
        // 获取当前日期
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth() + 1; // 月份从0开始，所以加1
        const currentDay = today.getDate();
        // 计算年龄
        let age = currentYear - Number(birthYear);
        if (currentMonth < Number(birthMonth) || (Number(currentMonth) === Number(birthMonth) && Number(currentDay) < Number(birthDay))) {
            age--;
        }
        return age;
      },
      getSexFromIdCard(idCard){
        if (!idCard || idCard.length !== 18) {
            return 0;
        }
        const sexCode = idCard.charAt(16);
        return sexCode % 2 === 0 ? 1 : 0;
      },
      /*
        初始页currentPage、初始每页数据数pagesize和数据data
      */
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        //改变每页显示的条数
        this.PageSize = val;
        this.queryOldman(); //刷新套餐列表的数据
      },
  
      /*
        当前页变化
      */
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.pageNo = val;
        this.queryOldman(); //刷新套餐列表的数据
      },
      downQRCodeLoad(){
        window.location.href =
          baseURL +
          `omc/api/downOldManSqQrcode?groupId=${window.sessionStorage.getItem("groupId")}`;
      },
      //导出
      downLoad() {
        window.location.href =
          baseURL +
          `omc/api/downOldManInformation?groupId=${window.sessionStorage.getItem("groupId")}`;
      },
      // 老人信息模板下载
      downOldManTemplateByGroup() {
        window.location.href = baseURL + `omc/api/downOldManTemplateByShequ`;
      },
      // 上传导入
      toLead() {
        this.toLeadVisisble = true;
      },
      toLeadCloseDialog() {
        this.$refs.file.value = "";
      },
      getUrl(event) {
        let file = event.target.files;
        console.log(file);
        this.fileFlag = true; //by guo 2020-8-4-15:18添加
        this.toLeadForm = new FormData();
        this.toLeadForm.append("file", file[0]);
      },
      // 确认上传
      intoForm() {
        if (this.fileFlag) {
          this.$postFormData("omc/Oldman/toLead", this.toLeadForm).then((res) => {
            this.toLeadVisisble = false;
            this.fileFlag = false;
            this.toLeadForm = {};
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
              this.getAdmissionData();
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          });
        } else {
          this.$message({ message: "请选择文件", type: "error" });
        }
      },
    },
    mounted() {
      this.queryOldman();
    },
    computed: {},
    created() {
      
    }
  };
  </script>
  <style lang="scss" scoped>
  .toolbar {
    padding-left: 8px;
    padding-top: 5px;
  }
  .curcor{
    cursor: pointer;
  }
  ::v-deep .el-dialog__header {
    height: 19px !important;
    text-align: left;
  }
  .demo-drawer__content{
    height: 100%;
  }
  .demo-drawer__footer{
    position: absolute;
    top: 95%;
    margin-left: 38px;
  }
  .width80 {
    width: 160px;
  }
  .width180 {
    width: 260px;
  }
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  
  .fenye {
    padding: 30px 0;
    margin: 0px auto;
    background: #fff;
  }
  </style>
    